import {isKrakenRolloutPath} from "@amzn/atoz-kraken-utility";

/**
 * Stage name and route table for this application.
 *
 * These live here, and not in src/index.tsx, so that importing them cannot drag
 * in that module's side effects.
 *
 * src/index.tsx is the standalone application entry, and evaluating it mounts the
 * application: it dynamically imports ./bootstrap, which calls createRoot() on
 * the element with id `atoz-my-hr-app-root`. That element belongs to the
 * AtoZMyHRApp host page. So when AtoZMyHRApp loads the federated ./MLEApp module
 * and anything in that subgraph imports from src/index, the host's own React root
 * is handed to a second, standalone copy of this application, along with a second
 * i18n instance, logger, and BrowserRouter.
 *
 * Today that mount throws rather than succeeding, because the host resolves React
 * 17 from the AtoZ shell and react-dom/client's createRoot delegates to a
 * react-dom that has no such export. The throw surfaces as an unhandled rejection
 * inside a dynamic import, with no visible effect, which is why the defect has
 * stayed latent. It stops being latent as soon as a host provides react-dom 18 to
 * this package's share scope.
 *
 * Holding the two values here keeps the federated subgraph away from
 * src/index.tsx, so the entry stays an entry.
 */
export const STAGE_NAME = 'prod';

const BASE = isKrakenRolloutPath() ? '/neverland-myhr' : '/myhr';

export const MLE_ROUTES = {
    FPP_URL: BASE + "/fpp",
    LIFE_EVENT_NAME_URL: BASE + "/fpp/:lifeEventName",
    HELPFUL_RESOURCES_URL: BASE + "/fpp/:lifeEventName/helpfulResources",
    POLICY_URL: BASE + "/fpp/:lifeEventName/policy",
    ARTICLE_URL: BASE + "/fpp/:lifeEventName/article",
    MML_CASE_SELECT_URL: BASE + "/fpp/:lifeEventName/mmlCaseSelect",
    MML_WORKFLOW_URL: BASE + "/fpp/:lifeEventName/mmlWorkflow",
    WORKFLOW_URL: BASE + "/fpp/:lifeEventName/workflow",
    TASK_PAGE_COMPOUND_ID_URL: BASE + "/fpp/:lifeEventName/:compoundTaskId",
    TASK_PAGE_COMPOUND_ID_STEP_URL: BASE + "/fpp/:lifeEventName/:compoundTaskId/step/:stepId",
    LIFE_CATEGORY_PAGE_URL: BASE + "/mle/:lifeEventCategory",
    LIFE_CATEGORY_LIFE_EVENT_URL: BASE + "/mle/:lifeEventCategory/:lifeEventName",
    LIFE_CATEGORY_LIFE_EVENT_WORKFLOW_URL: BASE + "/mle/:lifeEventCategory/:lifeEventName/workflow",
    LIFE_CATEGORY_LIFE_EVENT_RESOURCES_URL: BASE + "/mle/:lifeEventCategory/:lifeEventName/helpfulResources",
    LIFE_CATEGORY_LIFE_EVENT_POLICY_URL: BASE + "/mle/:lifeEventCategory/:lifeEventName/policy",
    LIFE_CATEGORY_LIFE_EVENT_ARTICLE_URL: BASE + "/mle/:lifeEventCategory/:lifeEventName/article",
    LIFE_CATEGORY_LIFE_EVENT_MML_CASE_SELECT_URL: BASE + "/mle/:lifeEventCategory/:lifeEventName/mmlCaseSelect",
    LIFE_CATEGORY_LIFE_EVENT_MML_WORKFLOW_URL: BASE + "/mle/:lifeEventCategory/:lifeEventName/mmlWorkflow",
    LIFE_CATEGORY_LIFE_COMPOUND_ID_URL: BASE + "/mle/:lifeEventCategory/:lifeEventName/:compoundTaskId",
    LIFE_CATEGORY_LIFE_COMPOUND_ID_STEP_URL: BASE + "/mle/:lifeEventCategory/:lifeEventName/:compoundTaskId/step/:stepId"
}
